import { Switch } from '@mantine/core'

export default {
    Switch: Switch.extend({
        defaultProps: {
            radius: 'md',
            variant: 'filled',
        }
    })
}